<script lang="ts" setup>
	import { twMerge } from 'tailwind-merge'

	interface ThumbnailsOpts {
		slidesPerView: number | string
		class?: string
		prev?: Object
		next?: Object
	}

	defineComponent({inheritAttrs: false})
	const { thumbnails = undefined, noLazy, slidesPerView = 1, ui = {} } = defineProps<{
		height?: string
		noLazy?: boolean
		thumbnails?: ThumbnailsOpts
		slidesPerView?: number | string
		ui?: Object
	}>()
	const emit = defineEmits(['select'])
	const items = defineModel<any[]>('items', {required: true})
	let attrs = useAttrs()

	const carousel = ref(null)
	const thumbs = useTemplateRef('thumbs')
	const activeIndex = ref(0)

	const onSelect = (index: any) => {
		if (slidesPerView === 1) {
			activeIndex.value = index
			emit('select', index)
			if (thumbnails && thumbs.value)
				thumbs.value.emblaApi.scrollTo(index)
		}
	}
	const select = (index: number) => {
		activeIndex.value = index
		carousel.value?.emblaApi.scrollTo(index)
		emit('select', index)
	}

	//ui.item = twMerge('basis-(--slides-per-view)', ui?.item)

	watch(items, (nv) => {
		const i = [...nv]
		while (slidesPerView > items.value.length) {
			for (const item of i)
				items.value.push(item)
		}
	}, {immediate: true})

	defineExpose({
		emblaApi: carousel.value?.emblaApi,
		activeIndex,
	})
</script>

<template>
	<ClientOnly>
		<UCarousel
			ref="carousel"
			v-bind="attrs"
			:items="items"
			:lazy="!noLazy"
			:ui="ui"
			:style="`--slides-per-view: calc(1/${slidesPerView} * 100%);`"
			@select="onSelect"
			#="{ item, index }"
		>
				<slot name="default" :index="index" :item="item" :isActive="carousel && slidesPerView > 1 ? carousel.emblaApi.slidesInView().includes(index) : index === activeIndex">
					<component :is="'LazyGsCarouselSlide'" :item="item" :index="index" :isActive="carousel && slidesPerView > 1 ? carousel.emblaApi.slidesInView().includes(index) : index === activeIndex" :lazy="!noLazy" :key="'test-'+index" />
				</slot>
		</UCarousel>
		<UCarousel
			v-if="thumbnails"
			ref="thumbs"
			class="mt-4"
			:items="typeof items[0] === 'string' ? items : items.map(i => i.url)"
			:lazy="!noLazy"
			:prev="{ variant: 'solid', color: 'accent', leadingIcon: 'i-mdi-chevron-left', ...(thumbnails.prev || {})}"
			:next="{ variant: 'solid', color: 'accent', leadingIcon: 'i-mdi-chevron-right', ...(thumbnails.next || {})}"
			:style="`--slides-per-view: calc(1/${thumbnails?.slidesPerView || 1} * 100%);`"
			:ui="{
				container: 'ms-0 me-0',
				prev: 'ms-15 mt-2',
				next: 'me-15 mt-2',
				item: twMerge('basis-(--slides-per-view) overflow-hidden',thumbnails.class),
			}"
			#="{ index, item }"
			arrows
		>
			<img v-lazy-load 
				:data-src="item"
				class="object-cover opacity-50 hover:opacity-100 transition-opacity"
				:class="{'opacity-100': activeIndex === index }"
				:alt="`thumbnail-${index}`"
				:loading="index === 0 ? 'eager' : 'lazy'"
				@click="select(index)"
			/>
		</UCarousel>
	</ClientOnly>
</template>
